<template>
    <div class="banner_image_abs">
        <div
            class="hero_image image_decor"
            :class="[imageFilterClass, { limit_width: limitWidth }]"
        >
            <picture v-full-image-path="image" />
        </div>

        <div class="banner_image_decor">
            <picture v-full-image-path:assets="'banner_image_decor.svg'" />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        image: {
            type: Object,
            required: true
        },

        imageFilterClass: {
            type: String,
            default: ''
        },

        limitWidth: {
            type: Boolean,
            required: false,
            default: false
        }
    }
};
</script>
